import axios from 'axios';

// REACT_APP_API_URL이 설정되어 있으면 우선 사용 (Cloudflare Pages 등)
const baseURL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production'
    ? 'https://bookrum-erp-backend.dx-ae3.workers.dev'
    : 'http://localhost:8787');

export const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

apiClient.interceptors.request.use((config) => {
  // Attach JWT from localStorage if present
  const token = localStorage.getItem('auth-token');
  if (token) {
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle 403 Forbidden errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if error is 403 Forbidden
    if (error.response?.status === 403) {
      // Redirect to unauthorized page
      // Use window.location to avoid circular dependencies with React Router
      if (window.location.pathname !== '/unauthorized') {
        window.location.href = '/unauthorized';
      }
    }
    // Re-throw the error so calling code can still handle it
    return Promise.reject(error);
  }
);

export default apiClient;
